<!--<h1>{{ "REGISTER.WELCOME_HEADER" | translate }}</h1>-->
<!--<h2>{{ queryParams.userid_hint }}</h2>-->
<!--<p class="mb30">{{ "REGISTER.WELCOME_LABEL" | translate }}</p>-->
<!-- Warning message for broken registration form -->

<span class="custom-login-info" style="padding-bottom: 10px; display: block">Konto erstellen</span>

<div class="warning info" *ngIf="!(isValidForm$ | async)">
    <span class="title">{{"WARNING.WARNING" | translate}}</span>
    <p>{{ "WARNING.WARNING_MESSAGE_FOR_BROKEN_REGISTRATION_FORM" | translate }}</p>
    <ul>
        <li *ngFor="let item of _validateFormData(fields, true)">
            {{item}}
        </li>
    </ul>
</div>
<!-- Warning message for broken registration form -->
<ng-container *cidPageLoader="pageLoading"></ng-container>
<!-- appearance: fill/legacy/standard/outline -->
<div class="formWrapper" *ngIf="(isValidForm$ | async)">
    <a class="custom-email-change-link" style="top: unset; right: 20px" tabindex="0" (keydown.enter)="changeEmail()" (click)="changeEmail()">ÄNDERN <i class="arrow right"></i></a>
    <dynamic-form
        [fields]="fields"
        [options]="dynamicFormOptions"
        [isSubmitted]="isSubmitBtnClicked"
        [dynamicfields]="dynamicFields"
        [enableDynamicFields]="enableDynamicFields"
        [appearance]="'standard'"
        (onSubmit)="_onSubmit($event)"
        (btnId)="_getFormId($event)"
        (formInstance)="_getDynamicFormGroup($event)"
    >
    </dynamic-form>

    <!--  <app-authentication-setup-->
    <!--    [methods]="allowedAuthMethods"-->
    <!--    (authSetup)="_changeAuthSetup($event)"-->
    <!--  >-->
    <!--  </app-authentication-setup>-->

    <dynamic-field-renderer
        *ngIf="enableDynamicFields"
        [fields]="dynamicFformFields"
        [group]="dynamicForm"
        [appearance]="'standard'"
    ></dynamic-field-renderer>

    <div class="mat-error">{{ errorMessage | translate }}</div>
</div>
<!--custom-->
<!--<p class="pw-hint">Das Passwort muss mindestens 8 Zeichen lang sein.</p>-->
<div fxLayout="column" fxLayoutAlign="space-around left" class="data-protection-content" style="margin-top: 20px;">
    <p class="globus-text">Datenschutz</p>
    <p class="info-text" *ngIf="isAppUser">Es gelten unsere <a href="af://openBrowser/https://www.globus-baumarkt.de/datenschutz/">Datenschutzbestimmungen</a> und <a href="af://openBrowser/https://www.globus-baumarkt.de/agb/">AGB</a>.</p>
    <p class="info-text" *ngIf="!isAppUser">Es gelten unsere <a href="https://www.globus-baumarkt.de/datenschutz/">Datenschutzbestimmungen</a> und <a href="https://www.globus-baumarkt.de/agb/">AGB</a>.</p>
    <p class="pw-hint">* Pflichtfelder</p>
</div>

<div class="section btn-group">
    <!--  <a [routerLink]="[]" (click)="_back()"-->
    <!--    ><label for="cidaasCancelBtn">{{ "BACK" | translate }}</label></a-->
    <!--  >-->
    <app-button [disabled]="btnDisabled" [btnOption]="buttonOptions.register" class="login-btn"> </app-button>
</div>
